import React, { Component, useState, useRef, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { Worker, Viewer, SpecialZoomLevel } from "@react-pdf-viewer/core";
import { searchPlugin } from "@react-pdf-viewer/search";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/search/lib/styles/index.css";
import * as styled from "./style";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

function highlightPattern(text, words) {
  const pattern = new RegExp(`(${words.join("|")})`, "gi"); // 'gi' for global and case-insensitive
  return text.replace(pattern, (match) => `<mark>${match}</mark>`);
}
function base64ToBlob(base64) {
  const binaryString = window.atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; ++i) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return new Blob([bytes], { type: "application/pdf" });
}
const PdfViewer = (props) => {
  const [numPages, setNumPages] = useState()
  const pdfViewer = useRef();
  const { keywords = [], base64, url: fileUrlProp, onClose } = props;
  const url = fileUrlProp || URL.createObjectURL(base64ToBlob(base64));
  const searchPluginInstance = searchPlugin({
    keyword: keywords.map((word) => {
      return {
        keyword: word,
        matchCase: true,
        // wholeWords: word.length > 1 ? false : true
        wholeWords: false
      };
    })
  });
  // useEffect(() => {
  //   pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.mjs`;
  // }, []);
  const textRenderer = useCallback(
    (textItem) => {
        return keywords.length ? highlightPattern(textItem.str, keywords) : textItem.str
    }
    ,
    [keywords]
  );
  // const shareWithDoximity = (e) => {
  //   e.preventDefault();
  //   const { doximity: { shareMessage, shareSubject } } = searchResources;
  //   const doximityUrlEncoded = encodeURIComponent(window.location.href);
  //   const doximityMessageEncoded = encodeURIComponent(shareMessage);
  //   const doximityShareSubjectEncoded = encodeURIComponent(shareSubject);
  //   const url = `${doximityShareUrl}?url=${doximityUrlEncoded}&message=${doximityMessageEncoded}&subject=${doximityShareSubjectEncoded}`;
  //   window.open(url, "_blank");
  // }
function onDocumentLoadSuccess({ numPages }) {
  setNumPages(numPages);
}
  return (
    <styled.ViewerContainer>
      {onClose && (
        <div style={{ textAlign: "right",
          margin: "12px" }}>
          <styled.CloseButton onClick={onClose}>✕ Close</styled.CloseButton>
        </div>
      )}
      <styled.PdfWrapper>
        <div style={{
          height: "100%",
          overflow: "hidden"
        }}>
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
            <Viewer
              fileUrl={url}
              plugins={[searchPluginInstance]}
              defaultScale={SpecialZoomLevel.PageWidth}
              ref={pdfViewer}
            />
          </Worker>
        </div>
      </styled.PdfWrapper>
      {/* <Document file={url} onLoadSuccess={onDocumentLoadSuccess} options={options}
        onItemClick={({pageNumber}) => {
          document.querySelector(`[data-page-number="${pageNumber}"`).scrollIntoView();
        }}
      >
      {Array.from(
        new Array(numPages),
        (el, index) => (
          <Page
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            customTextRenderer={textRenderer}
            scale={1}
            renderAnnotationLayer={true}
            renderInteractiveForms={true}
            renderTextLayer={true}
          />
        )
      )}
      </Document> */}
    </styled.ViewerContainer>
  );
};
PdfViewer.propTypes = {
  base64: PropTypes.string,
  url: PropTypes.string,
  keywords: PropTypes.array,
  onClose: PropTypes.func
};
export default PdfViewer;